import { render, staticRenderFns } from "./FormCreateSubcategory.vue?vue&type=template&id=37c8cb11&"
import script from "./FormCreateSubcategory.vue?vue&type=script&lang=js&"
export * from "./FormCreateSubcategory.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateSubcategory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports